import { render, staticRenderFns } from "./PeopleCreate.vue?vue&type=template&id=5ffdf089&"
import script from "./PeopleCreate.vue?vue&type=script&lang=js&"
export * from "./PeopleCreate.vue?vue&type=script&lang=js&"
import style0 from "./PeopleCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports